import React, { FC } from 'react';
import styles from './header_content.module.scss';

export const HeaderContent: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
